import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-list-cycle',
  templateUrl: './list-cycle.component.html',
  styleUrls: ['./list-cycle.component.scss'],
})
export class ListCycleComponent implements OnInit {
  filterText: string = '';
  filterCycles: any = [];
  cycles: any = [];
  breadcrumbs: any;
  page: number = 1;

  constructor(private api: ApiService) {}

  ngOnInit(): void {
    this.breadcrumbs = [
      {
        name: 'Agenda',
        path: '/dashboard/new-calendar',
        link: true,
      },
      {
        name: 'Lista de ciclos',
        link: false,
      },
    ];

    this.getCycles();
  }

  reloadInfo() {
    this.getCycles();
  }

  getCycles() {
    this.api.get('cycles').subscribe({
      next: (cycles) => {
        this.cycles = cycles.cycles;
        this.filterCycles = this.cycles;
      },
      error: (err) => {},
    });
  }

  clearSearch() {
    this.filterText = '';
    this.getCycles();
  }

  matches(listData: any, term: string) {
    return (
      listData.cycle.toLowerCase().includes(term.toLowerCase()) ||
      listData.year.toLowerCase().includes(term.toLowerCase())
    );
  }

  filterRecords() {
    const filterData = this.cycles.filter((data: any) => {
      return this.matches(data, this.filterText);
    });

    this.filterCycles = filterData;
  }
}
